module.exports = __webpack_public_path__ + "img/avatar6.f1d07258.png";